import React from "react";
import { CareRecipient } from "../../../../domain/care_recipient/CareRecipient";
import { RectangleIcon } from "../icons/RectangleIcon";
import { CareRecipientInfo } from "./CareRecipientInfo";
import { useNavigate } from "react-router-dom";
import { selectCareRecipientAction } from "../../../../state/usecase/care_recipient/actions";
import { useAppDispatch } from "../../../../state/store";

export const CareRecipientRow = React.memo(function CareRecipientRow(props: Props) {
    const { careRecipient } = props;
    const dispatch = useAppDispatch();

    const navigate = useNavigate();
    const onClick = () => {
        dispatch(selectCareRecipientAction(careRecipient));
        navigate(`/dash_board/${careRecipient.id.value}`);
    };

    return (
        <div className={"care_recipient_row"} onClick={onClick}>
            <div className="care_recipient_area">
                <CareRecipientInfo careRecipient={careRecipient} />
            </div>
            <div className={"rectangle"}>
                <RectangleIcon />
            </div>
        </div>
    );
});

type Props = {
    careRecipient: CareRecipient,
};
